import {  useDataSelector } from "./useData";

export function useEmitter() {
  return useDataSelector("emitter")
}
